import React from 'react';
import styled from 'styled-components';
import { breakpoint } from '../styling/mixins/breakpoints';
import { text } from '../styling/mixins/typography';
import { cells, section } from '../styling/utils/grid';
import EditorString from '../Components/EditorString/EditorString';
import { EditorStringModel } from '../Types/EditorString';

interface UspBlockProps {
  title?: string;
  items: UspItem[];
}

interface UspItem {
  title: string;
  imageUrl: string;
  text: EditorStringModel;
}

const StyledUspWrapper = styled.div`
  ${section}
  padding-top: 2.4rem;
  padding-bottom: 2.4rem;

  ${breakpoint('medium')} {
    padding-top: 2.4rem;
    padding-bottom: 2.4rem;
  }
  ${breakpoint('large')} {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }
`;

const StyledUspList = styled.ul`
  display: grid;
  ${cells(2)}
  gap: 1.6rem;

  ${breakpoint('medium')} {
    ${cells(4)}
  }
`;

const StyledUspItem = styled.li`
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    margin-bottom: 1.6rem;
    max-height: 24px;
  }

  h6 {
    margin-bottom: 0.8rem;
  }

  div {
    ${text('medium')}
    text-align: center;
  }
`;

const UspBlock = ({ items, title }: UspBlockProps) => {
  return (
    <StyledUspWrapper>
      <StyledUspList>
        {items.map((item, index) => (
          <StyledUspItem key={item.title + index}>
            <img src={item.imageUrl} alt={item.title} loading="lazy" />
            <h6>{item.title}</h6>
            <EditorString value={item.text.value} />
          </StyledUspItem>
        ))}
      </StyledUspList>
    </StyledUspWrapper>
  );
};

export default UspBlock;
